import useContentAsset from './use-content-asset'

const usePromoMeterConfig = (contentAssetId) => {
    const {data, isLoading, error} = useContentAsset(contentAssetId)

    const promoMeterConfig = (() => {
        try {
            if (!data?.contentAssetHTML) return null

            const content =
                typeof data.contentAssetHTML === 'string'
                    ? JSON.parse(data.contentAssetHTML)
                    : data.contentAssetHTML

            return {
                enabled: Boolean(content?.enabled),
                type: content?.type || null
            }
        } catch {
            return null
        }
    })()

    return {
        isLoading,
        error,
        promoMeterConfig,
        shouldReserveSpace: promoMeterConfig?.enabled === true
    }
}

export default usePromoMeterConfig
